import {
  SELECIONA_MODAL_LOGOUT,
  SELECIONA_MODAL_TABLEAU,
} from "../actions/actionsConstants";

export const initialState = {
  ModalLogoutAberto: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SELECIONA_MODAL_LOGOUT:
      return { ...state, ModalLogoutAberto: action.payload };
    case SELECIONA_MODAL_TABLEAU:
      return { ...state, ModalTableauAberto: action.payload };

    default:
      return state;
  }
};
